<div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom secondaryMenu px-4 py-3">
    <div class="d-flex flex-column col">
        <h3 class="mt-0 mb-1">Job Request Details</h3>
        <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
    <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
        <button pButton type="button" icon="pi pi-check-circle" label="Approve" iconPos="left"  class="p-button-success me-3" (click)="showBasicDialog()" ></button>
        <button pButton type="button" icon="pi pi-times-circle" label="Reject" iconPos="left" class="p-button-danger" (click)="showBasicDialog2()"></button>
    </div>
</div>
    
<div class="row mx-0 jobRequestDetails">
    <div class="col-12 col-sm-12 col-md-8 px-0">
        <div class="m-3 p-white shadow-sm bg-aqua p-3">
            <div class="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center mb-4">
                <div>
                    <h4 class="mt-0 mb-0">Vehicle Running Charges - IN000000023</h4>
                </div>
                <div class="d-flex flex-column justify-content-end mt-2 mt-md-0 progressWrapper">
                    <div class="d-flex justify-content-end mb-1">
                        <small>10/10 Steps</small>
                    </div>
                    <div class="prog-bar-full"><p-progressBar [value]="100"></p-progressBar></div>    
                </div>
            </div>
            
            <div class="d-flex flex-column mb-4">
                <table class="jobrequestdetailsTable">
                    <tbody>
                        <tr>
                            <td>Company</td>
                            <td>Idea Factory Outlet</td>
                        </tr>
                        <tr>
                            <td>Operation</td>
                            <td>Vehicle Running Charges</td>
                        </tr>
                        <tr>
                            <td>Requested by</td>
                            <td>ishan madushanka </td>
                        </tr>
                        <tr>
                            <td>Contact Number</td>
                            <td>0111234567</td>
                        </tr>
                        <tr>
                            <td>Budget Line</td>
                            <td>N/A</td>
                        </tr>
                    </tbody>
                </table>

                <table class="budgetBalanceTable my-4">
                    <tbody>
                        <tr >
                            <td>Balance of Budget</td>
                            <td>50,000</td>
                        </tr>
                    </tbody>
                </table>

                <table class="jobrequestdetailsTable">
                    <tr>
                        <td><b>Job value</b></td>
                        <td>25,000 </td>
                    </tr>
                    <tr>
                        <td><b>Due Date</b></td>
                        <td>2021 Aug 21</td>
                    </tr>
                    <tr>
                        <td><b>Description</b></td>
                        <td>unloading</td>
                    </tr>
                </table>

                <div class="mt-4">
                    <img src="/assets/img/bill.png" />
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 col-sm-12 col-md-4 px-0">
        <div class="m-3 p-white shadow-sm p-3">
            <h4 class="mt-0 mb-4">Job Chain</h4>

            <p-timeline [value]="events1" align="left" styleClass="customized-timeline">
                <ng-template pTemplate="marker" let-event>
                    <span class="custom-marker p-shadow-2">
                        <div [ngClass]="event.iconclass" ></div>
                    </span>
                </ng-template>
                <ng-template pTemplate="content" let-event>
                    <div [ngClass]="event.class" class="p-3">
                        <p class="step-text mt-0 mb-0">Request Created.</p>
                        <p class="step-text mt-0 mb-0">2021 Auguts 21, 10:21 AM</p>
                    </div>
                </ng-template>
            </p-timeline>
        </div>
    </div>
</div>


<p-dialog header="Approve Request" [(visible)]="displayBasic" [style]="{width: '50vw'}" [baseZIndex]="10000">
    <table class="requestedamountTable mb-3" style="width: 100%; border-spacing :0px;">
        <tbody>
            <tr style="background-color:var(--yellow-50);">
                <td style="padding:12px; font-size: 14px; width: 50%;">Balance of Budget</td>
                <td style="padding:12px; font-size: 14px; width: 50%;">50,000</td>
            </tr>
            <tr style="background-color:var(--green-50);">
                <td style="padding:12px; font-size: 14px; width: 50%;">Job Value</td>
                <td style="padding:12px; font-size: 14px; width: 50%;">25,000</td>
            </tr>
            
        </tbody>
    </table>
    <div class="d-flex flex-column mb-3">
        <label class="mb-2">Approved Value</label>
        <input type="text" pInputText> 
    </div>
    <div class="d-flex flex-column mb-4">
        <label class="mb-2">Chain Transaction</label>
        <p-dropdown placeholder="Select Chain Transaction"  optionLabel="name"></p-dropdown>
    </div>
    <div class="d-flex flex-column mb-4">
        <label class="mb-2">Add your remark</label>
        <textarea rows="5" cols="30" pInputTextarea></textarea>
    </div>
    <ng-template pTemplate="footer">
        <button pButton type="button" icon="pi pi-check-circle" label="Approve" iconPos="left"  class="p-button-success me-3" ></button>
        <button pButton type="button" label="Cancel"  class="p-button-outlined"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Reject Request" [(visible)]="displayBasic2" [style]="{width: '50vw'}" [baseZIndex]="10000">
    <table class="requestedamountTable mb-3" style="width: 100%; border-spacing :0px;">
        <tbody>
            <tr style="background-color:var(--yellow-50);">
                <td style="padding:12px; font-size: 14px; width: 50%;">Balance of Budget</td>
                <td style="padding:12px; font-size: 14px; width: 50%;">50,000</td>
            </tr>
            <tr style="background-color:var(--green-50);">
                <td style="padding:12px; font-size: 14px; width: 50%;">Job Value</td>
                <td style="padding:12px; font-size: 14px; width: 50%;">25,000</td>
            </tr>
            
        </tbody>
    </table>
    <div class="d-flex flex-column mb-4">
        <label class="mb-2">Add your remark</label>
        <textarea rows="5" cols="30" pInputTextarea></textarea>
    </div>
    <ng-template pTemplate="footer">
        <button pButton type="button" icon="pi pi-check-circle" label="Reject" iconPos="left"  class="p-button-danger me-3" ></button>
        <button pButton type="button" label="Cancel"  class="p-button-outlined"></button>
    </ng-template>
</p-dialog>